import _ from "underscore";
import clsx from "clsx";
import Drawer from "@material-ui/core/Drawer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Hidden from "@material-ui/core/Hidden";
import I18n from "./locale/I18n.js";
import IconButton from "@material-ui/core/IconButton";
import Link from "./Link.js";
import LocaleSelector from "./LocaleSelector.js";
import { makeStyles } from "@material-ui/core/styles";
import React from "react";

const useStyles = makeStyles(theme => ({
    link: {
        fontVariantCaps: "caps",
        textDecoration: "none",
        color: "#777", //theme.palette.primary.main,
        fontSize: "1.2rem",
        padding: theme.spacing(1),
        "&:hover": {
            backgroundColor: "#eee"
        }
    },
    drawerLink: {
        paddingTop: theme.spacing(2),
        paddingBottom: theme.spacing(2)
    },
    nav: {
        display: "flex",
        justifyContent: "flex-end"
    },
    drawer: {
        width: "300px"
    },
    drawerHead: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between"
    },
    drawerLocale: {
        padding: theme.spacing(2)
    }
}));

const NavItems = [
    {
        id: "Home",
        target: "/",
        label: "Nav_Home"
    },
    {
        id: "Learning",
        target: "/IsyLearning",
        label: "Product_Learning"
    },
    {
        id: "Vet",
        target: "/IsyVet",
        label: "Product_Vet"
    }
];

const LargeScreenNav = props => {
    const classes = useStyles();
    return (
        <div>
            <div className={classes.nav}>
                {_.map(NavItems, item => (
                    <Link target={item.target} className={classes.link}>
                        <I18n label={item.label} />
                    </Link>
                ))}
            </div>
            <div>
                <LocaleSelector />
            </div>
        </div>
    );
};

const SmallScreenNav = props => {
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();
    return (
        <>
            <LocaleSelector hidden />
            <IconButton onClick={() => setOpen(true)}>
                <FontAwesomeIcon icon={["far", "bars"]} />
            </IconButton>
            {open && (
                <Drawer
                    anchor="right"
                    className={classes.drawer}
                    open={open}
                    onClose={() => setOpen(false)}
                    PaperProps={{
                        className: classes.drawer
                    }}
                    style={{ width: "350px" }}
                >
                    <div className={classes.drawerHead}>
                        <IconButton onClick={() => setOpen(false)}>
                            <FontAwesomeIcon icon={["far", "times"]} />
                        </IconButton>
                        <div className={classes.drawerLocale}>
                            <LocaleSelector />
                        </div>
                    </div>
                    {_.map(NavItems, item => (
                        <Link
                            key={item.id}
                            target={item.target}
                            className={clsx(classes.link, classes.drawerLink)}
                        >
                            <I18n label={`Nav_${item.id}`} />
                        </Link>
                    ))}
                </Drawer>
            )}
        </>
    );
};

const Nav = props => {
    return (
        <div>
            <Hidden smDown>
                <LargeScreenNav />
            </Hidden>
            <Hidden mdUp>
                <SmallScreenNav />
            </Hidden>
        </div>
    );
};

export default Nav;
